export enum InvitationStatus {
  OPEN = 0,
  ACCEPTED = 1,
  REJECTED = 2,
  CANCELED = 3,
}

export enum ChatType {
  Global,
  Family,
}

export enum Gender {
  MALE = 0,
  FEMALE = 1,
}

export type InventoryType = "Items" | "NFTs" | "All";

export enum ItemCategory {
  CASH = 0,
  BULLET = 1,
  HEALTH = 2,
  SHOPITEM = 3,
  BUSINESS = 4,
  BODYGUARD = 5,
  CREDIT = 6,
  CAR = 7,
  KEY = 8,
  KEYITEMS = 9,
  MAFIA = 10,
  OGNFT = 11,
  NOTICREDIT = 12,

  LANDSLOT = 13,
  BUSINESS_EXTRA = 14,

  CAR_ITEM = 15,
  FBI_ASSETS = 16,
}

export enum AnimationStatus {
  Stopped = 0,
  SpeedUp = 1,
  Playing = 2,
  SpeedDown = 3,
}

export enum FamilyRole {
  Don = 0,
  Consigliere = 1,
  Capodecina = 2,
  Capo1 = 3,
  Capo2 = 4,
  Capo3 = 5,
  Capo4 = 6,
  Capo5 = 7,
  Successor = 8,
  Member = 9,
}

export enum ChainType {
  BNB = "BNB",
  PLS = "PLS",
}

export enum MarketSSEEventHeader {
  NewListing = "NewListing",
  ItemPurchased = "ItemPurchased",
  NewBid = "NewBid",
  CancelListing = "CancelListing",
}

export enum AllegiancePopupContent {
  Join,
  Create,
  Manage,
}

export enum NotificationType {
  FamilyInvitation = 0,
  AllegianceInvitation = 1,
  AllegianceRequest = 2,
  OTCRequest = 5,
  JailBustedEvent = 6,
  JailBuyOutEvent = 7,
}

export enum DaoProposalStatus {
  Pending = 0,
  Opened = 1,
  Closed = 2,
  Canceled = 3,
}

export enum SmugglingActionType {
  Buy,
  Sell,
}

export enum HelperBotType {
  CrimeBot = 0,
  GrandTheftAutoBot = 1,
  ShootingPracticeBot = 2,
  BoozeSmugglingBot = 3,
  NarcoticsSmugglingBot = 4,
  BulletDealerBot = 5,
}

// If you need to map the enum values to display strings, create a separate object:
export const HelperBotTypeLabels: Record<HelperBotType, string> = {
  [HelperBotType.CrimeBot]: "Crime bot",
  [HelperBotType.GrandTheftAutoBot]: "Grand theft auto bot",
  [HelperBotType.ShootingPracticeBot]: "Shooting practice bot",
  [HelperBotType.BoozeSmugglingBot]: "Booze smuggling bot",
  [HelperBotType.NarcoticsSmugglingBot]: "Narcotics smuggling bot",
  [HelperBotType.BulletDealerBot]: "Bullet dealer bot",
};

export type RankType = "Low" | "Medium" | "High";
